<span *ngIf="controlName.touched">
  <small class="text-danger" *ngFor="let errorMessage of listErrors(); let last = last">
    {{ last ? errorMessage : '' }}
  </small>
</span>
